export const T1_OWNER = 1;
export const T1_OWNERSETTING = 2;
export const T1_OFFICE = 3;
export const T1_OFFICESETTING = 4;
export const T1_SHOP = 5;
export const T1_SHOPSETTING = 6;
export const T1_SHOPMIDGROUP = 7;
export const T1_OFFICEINFO = 8;
export const T1_SP = 9;
export const T1_SPAPPLY = 10;
export const T1_HIME = 11;
export const T1_HIMESHOP = 12;
export const T1_STAFF = 13;
export const T1_DRIVER = 14;
export const T1_SCOUT = 15;
export const T1_SCOUTCMP = 16;
export const T1_USER = 21;
export const T1_USEROFFICE = 22;
export const T1_USERPOINT = 23;
export const T1_RESV = 24;
export const T1_CALL = 25;
export const T1_HIMEUSER = 26;
export const T1_HIMEDAY = 31;
export const T1_FIXDAY = 32;
export const T1_SCHEDULEMEMO = 33;
export const T1_SCHEDULEDRIVER = 34;
export const T1_SCHEDULEHIME = 35;
export const T1_REPORT = 36;
export const T1_MONEYEXCH = 37;
export const T1_NOTICE = 38;
export const T1_DELETEDITEM = 41;
export const T1_CMD_ALERT = 101; // パラメータ：対象のstaffの一覧, 表示するメッセージ
export const T1_CMD_LOGOUT = 102; // パラメータ：対象のstaffの一覧, メッセージ(任意)
export const T1_CMD_CLEARCACHE = 103;
export const T1_CMD_PCMAINOUT = 104; // パラメータ：hwKey
export const T1_CMD_JSVERSION = 105;
export const T1_CMD_NETEXTRESULT = 106;
export const T1_CMD_TESTLINE = 107;

export const NONE = 0;
export const T2_CREATE = 11; // パラメータ例：user
export const T2_CREATE_LIST = 12; // パラメータ例：userList
export const T2_DELETE = 21; // パラメータ例：id
export const T2_DELETE_LIST = 22; // パラメータ例：idList
export const T2_UPDATE = 31; // パラメータ例：id, diff
export const T2_UPDATE_LIST = 32; // パラメータ例：idList, diffList
export const T2_REPLACE = 41; // パラメータ例：user
export const T2_REPLACE_LIST = 42; // パラメータ例：userList
export const T2_CLEAR = 51;
export const T2_UIDCHANGE = 71; // パラメータ例：idFrom, idTo
export const T2_BLN = 11;